import {createRouter, createWebHashHistory} from 'vue-router'
import Home from "@/views/home/home.vue";

const routes = [
    {
        path: '/',
        name: '/',
        component: Home
    },
    {
        path: '/Notice',
        name: 'Notice',
        component: () => import('../views/notice/notice.vue'),
    },
    {
        path: '/unNotice',
        name: 'unNotice',
        component: () => import('../views/notice/unnotice.vue')
    },
    {
        path: '/Result',
        name: 'Result',
        component: () => import('../views/result/result.vue'),
    },
    {
        path: '/unResult',
        name: 'unResultv',
        component: () => import('../views/result/unresult.vue')
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/detail/detail.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/detail/newsDetail.vue')
    },
    {
        path: '/search',
        name: 'search',
        component: () => import('../views/search/search.vue')
    },
    {
        path: '/financial',
        name: 'financial',
        component: () => import('../views/financial/financial.vue')
    },
    {
        path: '/opinion',
        name: 'opinion',
        component: () => import('../views/opinion/opinion.vue')
    },
    {
        path: '/consult',
        name: 'consult',
        component: () => import('../views/consult/consult.vue')
    }

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
